import React from "react";

const PlaycanvasContext = React.createContext<any | null>(null);

export default PlaycanvasContext;
